import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";

const AdminSetting = () => {
  const [dollarRate, setDollarRate] = useState("");

  useEffect(() => {
    const fetchDollarRate = async () => {
      try {
        const response = await axios.get(`${baseurl}getDollarRate`);
        if (response.data.success && response.data.rate) {
          setDollarRate(response.data.rate);
        }
      } catch (error) {
        console.error("Error fetching dollar rate:", error);
        // Optional: show alert or toast
      }
    };
  
    fetchDollarRate();
  }, []);
  

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!dollarRate.trim()) {
      Swal.fire("Validation Error", "Dollar rate is required", "warning");
      return;
    }

    try {
      const response = await axios.post(`${baseurl}setDollarRate`, {
        rate: dollarRate,
      });
      console.log("💸 Dollar Rate Saved:", response.data);
      Swal.fire("Success", "Dollar rate saved successfully", "success");
    } catch (error) {
      console.error("❌ Error saving rate:", error);
      Swal.fire("Error", "Failed to save rate", "error");
    }
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />

        <div className="container-fluid">
          <h4 className="mb-3 text-start">Set Dollar Rate (INR)</h4>

          <div className="crd1 mb-3">
            <form onSubmit={handleSubmit}>
              <div className="row mb-3 text-start">
                <div className="col-md-4">
                  <label className="form-label">Dollar Rate in INR</label>
                  <input
                    type="number"
                    step="0.01"
                    name="dollarRate"
                    className="form-control"
                    placeholder="Enter Dollar Rate (e.g., 83.25)"
                    value={dollarRate}
                    onChange={(e) => setDollarRate(e.target.value)}
                  />
                </div>
              </div>

              <div className="text-start mt-3">
                <button type="submit" className="btn btn-primary">
                  Save Rate
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSetting;
